const ContactlessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        fill="#15DBCD"
        fillRule="evenodd"
        d="M20 37c9.389 0 17-7.611 17-17S29.389 3 20 3 3 10.611 3 20s7.611 17 17 17zm0 3c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#15DBCD"
        fillRule="evenodd"
        d="M6.707 31.293a1 1 0 000 1.414l1.414 1.414a1 1 0 001.415 0l6.938-6.938a8.035 8.035 0 01-3.042-2.615l-6.725 6.725zM24.568 13.43a8.035 8.035 0 012.615 3.043l7.101-7.102a1 1 0 000-1.414L32.87 6.544a1 1 0 00-1.414 0l-6.888 6.887z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#3365FF"
        d="M30.8 18.8h-1.286a9.529 9.529 0 00-1.942-4.68l1.678-1.668a1.207 1.207 0 10-1.702-1.704l-1.668 1.68a9.527 9.527 0 00-4.68-1.944V9.2a1.2 1.2 0 10-2.399 0v1.284a9.527 9.527 0 00-4.68 1.944l-1.67-1.68a1.206 1.206 0 00-1.704 1.704l1.68 1.669a9.53 9.53 0 00-1.943 4.679H9.2a1.2 1.2 0 100 2.4h1.286a9.516 9.516 0 001.942 4.681l-1.679 1.669a1.208 1.208 0 00.837 2.108 1.207 1.207 0 00.866-.406l1.668-1.678a9.561 9.561 0 004.681 1.944V30.8a1.2 1.2 0 102.4 0v-1.282a9.527 9.527 0 004.679-1.946l1.668 1.68a1.206 1.206 0 101.703-1.702l-1.679-1.669a9.527 9.527 0 001.944-4.681H30.8a1.2 1.2 0 000-2.4zm-3.708 2.402a7.2 7.2 0 01-5.891 5.893 1.2 1.2 0 10-2.4 0 7.2 7.2 0 01-5.893-5.893 1.2 1.2 0 100-2.4 7.203 7.203 0 015.893-5.891 1.2 1.2 0 002.4 0 7.198 7.198 0 015.889 5.891 1.2 1.2 0 100 2.4h.002z"
      ></path>
      <path
        fill="#3365FF"
        fillRule="evenodd"
        d="M20.5 28.998a8.45 8.45 0 006.217-2.713 8.497 8.497 0 002.254-6.502 8.534 8.534 0 00-2.854-5.658 8.487 8.487 0 00-11.729.476A8.539 8.539 0 0012 20.472v.002a8.546 8.546 0 002.489 6.029A8.499 8.499 0 0020.499 29v-.002zm4.857-10.35a1.832 1.832 0 01-1.11 1.744 1.818 1.818 0 01-2.412-1.026 1.832 1.832 0 01-.121-.718 1.83 1.83 0 01.563-1.236 1.82 1.82 0 013.078 1.236h.002zm-7.288.608a1.221 1.221 0 01-.75 1.125 1.211 1.211 0 01-1.586-.659 1.221 1.221 0 01.263-1.327 1.213 1.213 0 012.073.861zm2.429 4.871a1.212 1.212 0 001.214-1.217 1.22 1.22 0 00-1.214-1.218 1.213 1.213 0 00-1.215 1.218 1.22 1.22 0 001.215 1.217z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default ContactlessIcon;
